<!--<button class="ft-edit" (click)="openContent()" *ngIf="CanEdit === 1 "></button>-->

  <!--<button (click)="openContent()" *ngIf="CanEdit === 1 "
          type="Browse" class="btn btn-primary btn-sm" id="FileUpload"
          name="upload" data-toggle="modal" data-target=".ex-modal-lg"><i class="fas fa-plus"></i>
  </button>-->

  <button type="button" (click)="openContent()" *ngIf="CanEdit === 1 " class="btn btn-primary btn-sm" id="FileUpload"
          name="upload" title="Click To Add Your Photo">
    <i class="fas fa-plus"></i>
  </button>


<!--<button type="button"  (click)="openContent()" *ngIf="CanEdit === 1 " class="btn btn-primary btn-sm" id="FileUpload"
        name="upload" >
  <i class="fas fa-plus"></i>
</button>-->


  <div *ngIf="CanShowRegistryView === 1 ">
    <div class="row card-deck">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">

      </div>
    </div>
  </div>
